import { createFileRoute } from '@tanstack/react-router';

import { CreateBillingGroupContainer } from '@/features/billing-groups/containers/create-billing-group';

export const Route = createFileRoute('/_layout/billing-groups/create')({
  component: CreateBillingGroupContainer,
});
